/* tslint:disable */
/* eslint-disable */
export enum AccountAttributeName {
  SELF_CERTIFICATION = 'SELF_CERTIFICATION'
}
